import { BaseInput } from './base-input';

export class TextboxInput extends BaseInput {
  public constructor(data: any) {
    super(data);
  }
}
